<app-grocery-category-items-horizontal-list
  #groceryItemsCategories
  [serviceType]="serviceType"
  [address]="address"
  [vendorDetails]="vendorDetails"
  [categoryItem]="categoryItem"
  [parentCategoryInfo]="parentCategoryInfo"
  *ngFor="let categoryItem of categories"
></app-grocery-category-items-horizontal-list>
